import React from 'react';

interface AlyzeLogoFullProps {
  className?: string;
  color?: string;
}

export const AlyzeLogoFull: React.FC<AlyzeLogoFullProps> = ({ 
  className = '', 
  color = '#444444' 
}) => {
  return (
    <svg 
      width="1569" 
      height="308" 
      viewBox="0 0 1569 308" 
      fill="none" 
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_1584_2047)">
        <path 
          d="M153.654 66.1149L67.4028 292.663C64.2521 301.854 55.7002 308 46.1917 308H0L106.73 15.5666C110.106 6.20366 118.827 0 128.56 0H190.168C199.958 0 208.679 6.2611 211.998 15.624L318.279 308.057H272.143C262.578 308.057 254.083 301.911 250.932 292.721L164.625 66.1149C162.824 60.7729 155.454 60.7729 153.654 66.1149Z" 
          fill={color}
        />
        <path 
          d="M415.613 0H477.671V251.42H606.4V308.057H415.613V0Z" 
          fill={color}
        />
        <path 
          d="M931.037 0L814.517 180.768V308.057H752.966V180.768L636.445 0H690.739C701.316 0 711.106 5.51436 716.732 14.6475L779.071 115.572C781.378 119.248 786.667 119.248 788.917 115.572L850.806 14.7624C856.433 5.62924 866.279 0.0574413 876.856 0.0574413H931.093L931.037 0Z" 
          fill={color}
        />
        <path 
          d="M1260.85 0V56.6371L1094.65 251.42H1260.85V308.057H1021.56V251.42L1187.82 56.6371H1021.56V0H1260.85Z" 
          fill={color}
        />
        <path 
          d="M1423.67 56.6371V125.739H1541.26L1533.39 164.11C1531.19 174.736 1522.02 182.376 1511.39 182.376H1423.67V251.478H1569.06V308.115H1362.12V0H1569.06V56.6371H1423.67Z" 
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_1584_2047">
          <rect width="1569" height="308" fill="white"/>
        </clipPath>
      </defs>
    </svg>
  );
};
